exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.item {\n  margin-top: 0px;\n  margin-right: 20px;\n}\n", ""]);

// exports
